<style lang="stylus" scoped>
@import './monthly.styl';

</style>
<template>
  <div>
    <div class="mark" v-if="mark" >
      <el-progress type="circle"  :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <el-row class="el-year">
      <el-col :span="1" @click.native="preYear">
        <i class="el-icon-arrow-left"></i>
      </el-col>
      <el-col :span="22" class="export-title">{{getCurrentTitle()}}</el-col>
      <el-col :span="1" @click.native="nextYear">
        <i class="el-icon-arrow-right"></i>
      </el-col>
    </el-row>
    <el-row class="el-btn-m">
      <el-checkbox-group v-model="checkList">
        <el-col :span="colsCount" v-for="item in mouthData" :key="item.key">
            <el-checkbox
              :label="item.key"
              :disabled="item.isDisabled"
              @change="changeCheck(item)"
            >{{item.name}}</el-checkbox>
        </el-col>
      </el-checkbox-group>
    </el-row>
    <el-row v-if="showBottomButton" class="more-export">
      <el-col :span="12">
        <el-button @click="hideExport">取消</el-button>
      </el-col>
      <el-col :span="12">
        <el-button type="primary" @click="confirmExport">{{okLabel}}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import https from '@/api/freight.js'
import http from '@/api/cardData'
import Cookies from 'js-cookie'
import each from 'lodash/each'
import join from 'lodash/join'
import map from 'lodash/map'
import chunk from 'lodash/chunk'
import size from 'lodash/size'
import some from 'lodash/some'
import every from 'lodash/every'
import includes from 'lodash/includes'
import get from 'lodash/get'
import set from 'lodash/set'
import clone from 'lodash/clone'
import toInteger from 'lodash/toInteger'
import cloneDeep from 'lodash/cloneDeep'
import { exportExport , getRequestParam , isCheckMore , baseExportPrepare} from './util.js'
export default {
  props: {
    dateSeparator: {
      type: String,
      default: "-"
    },
    isItemBindClick: {
      type: Boolean,
      default: false
    },
    dimObj: {
      type: Object,
      default(){
        return {
          "year":new Date().getFullYear(),
          "month":'01',
          "type":'0'
        }
      },
    },
    isMapValue: {
      type: Boolean,
      default: false
    },
    openType: {//打开类型  dialog|popover
      type: String,
      default: 'dialog'
    },
    okLabel: {
      type: String,
      default: '确认导出'
    },
    params:{
      type:Object,
      default(){
        return {}
      }
    },
    isSingleSelect: {//是否单选
      type: Boolean,
      default: true
    },
    showBottomButton: {
      type: Boolean,
      default: true
    },
    tabObj: {
      type: Object,
      default: {}
    },
    moduleName: {
      type: String,
      default: ''
    },
    provinceName: {
      type: String
    },
    provinCode: {
      type: String
    },
    pathwayCityCode: {
      type: String
    },
    cityName: {
      type: String
    },
    tab: {
      type: Number
    },
    oilBrand: {
      type: String
    },
    condition: {
      type: String
    },
    roadCode: {
      type: String
    },
    toExportDetail: {
      type: [Function, String],
      default: ''
    },
    beforeExportFunc: {
      type: Function,
      default: () => true
    },
    clickItem: {
      type: Function,
      default: () => {
        console.log("clickItem");
      }
    },
  },
  data() {
    let tmpDimObj=cloneDeep(this.dimObj);
    return {
      checkList: [],
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      mouthShow: true,
      mouthData: [],
      /*mouthAll: [
        '1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'
      ],*/
      mouthAll:[],
      colsCount:6,
      selecedYear: '',
      tempChooseArr: [],
      mouthFlag: [],
      typeCount:1,
      tmpDimObj,
    }
  },
  mounted() {},
  created() {
    this.showAddTow = true
    this.mouthAll=this.tabObj.items;
    this.colsCount = this.tabObj.colsCount;
    this.typeCount = this.tabObj.typeCount;
    let num = toInteger(this.tabObj.selecedYear)
    let count=size(this.tabObj.items);
    let i = num%count;
    this.selecedYear =""+(num - i);
    this.getendMonth()
  },
  beforeDestroy() {},
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    }
  },
  methods: {
    getendMonth() {
      this.initMonthData()
    },
    hideExport() {
      if(this.openType==="popover"){
        this.clickItem();
      }else{
        this.$emit('hideExport')
      }
    },
    returnTime(tempChooseArr) {
      let labels = [];
      let values = [];
      let year=[];
      let month=[];
      for (let v of tempChooseArr) {
        let {mouthArr , mouthFlag} = v;
        for (let val of mouthArr) {
          let yearName = get(this,["mouthData",val,"name"],"")
          let value = "";//"01";
          labels.push(yearName+"年");
          values.push(yearName + value);
          year.push(yearName);
          month.push(value);
        }
      }
      return {
        labels:join(labels,","),
        values:join(values,","),
        year:join(year,","),
        month:join(month,","),
      }
    },
    hasItem(tempChooseArr) {
      if(tempChooseArr.length == 0){
        return true;
      }else{
        var arr = map(tempChooseArr,it=>{
          return size(it.mouthArr)===0;
        })
        let flag = every(arr);
        return flag;
      }
    },
    //导出
    confirmExport() {
      if(typeof this.beforeExportFunc === "function" && !this.beforeExportFunc()) return

      let that = this
      let tempChooseArr = this.tempChooseArr
      if (this.hasItem(tempChooseArr)) {
        let label = get(this,"tabObj.label","");
        this.$message({
          message:  `至少要选择一个${label}!!`,
          type: 'warning'
        })
        return
      }
      this.mouthShow = false
      let obj = this.returnTime(tempChooseArr);
      obj.type=this.tabObj.code;
      obj.isOk=true;
      let yearMonths = obj.values;
      if(this.openType==="popover"){
        this.clickItem(obj);
        return
      }
      let moduleName = this.moduleName
      that.mark = true
      let reqId = Cookies.get('user')
      window.times = setInterval(function() {
        http[that.allTab].progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.$emit('hideExport')
            that.progressNum = 0
            clearInterval(window.times)
          }
        })
      }, 100)
      reqId += new Date() * 1

      // 传入函数进行执行
      if (that.toExportDetail) {
        that.toExportDetail(yearMonths, reqId)
        return
      }

      //导出
      exportExport(reqId,that,obj);
    },
    initMonthData() {
      var that = this
      this.checkList = []
      this.mouthData = []
      this.mouthFlag = []
      let selecedYear = this.selecedYear
      this.mouthData = map(this.tabObj.items,(it,index)=>{
        let isDisabled = true;
        //let isClick = false;
        let isClick = isDisabled;
        let name = ""+(toInteger(this.selecedYear)+index);
        return {
          name,
          isDisabled,
          key: index,
          isClick,
        }
      });
      this.onAdjustState();
      if(this.isMapValue&&this.tabObj.code===this.tmpDimObj.type){
        if(this.isSingleSelect){
          let i = get(this,"tmpDimObj.year","0");
          let j = get(this,"selecedYear","0");
          let index = toInteger(i)-toInteger(j);;
          this.checkList.push(index);
          this.baseChangeCheck();
        }
      }
      isCheckMore(this)
      let tempChooseArr = this.tempChooseArr
      for (var v of tempChooseArr) {
        if (v.yearName == selecedYear) {
          this.checkList = v.mouthArr
        }
      }
    },
    setEnableButton(index){
      set(this,["mouthData",index,"isDisabled"],false)
      set(this,["mouthData",index,"isClick"],false)
    },
    onAdjustState(){
      if(this.openType==="dialog"){
        each(this.mouthData,(it,index)=>{
          this.setCheckState(this,it.name,index);
        })
      }else if(this.openType==="popover"){
        this.$nextTick(it=>{
          each(this.mouthData,(it,index)=>{
            this.setEnableButton(index);
          })
        });
      }
    },
    setCheckState(that,selecedYear,index){
      console.log('...')
      baseExportPrepare(this,selecedYear,index);
    },
    onResponse(e,index){
      let str = 'ok'
      let arr = map(e.data,it=>{
        return includes(it,str);
      });
      if(size(arr)>0&&every(arr)){
        this.setEnableButton(index);
      }
    },
    baseChangeCheck() {
      let selecedYear = this.selecedYear
      let checkList = this.checkList
      let tempChooseArr = this.tempChooseArr
      let mouthFlag = this.mouthFlag
      if(this.isSingleSelect){//如果 单选，去掉之前的
        if(size(checkList)>1){
          checkList.shift();
        }
      }
      if (tempChooseArr.length > 0) {
        var isPush = true
        for (var v of tempChooseArr) {
          if (v.yearName == selecedYear) {
            isPush = false
            v.mouthArr = checkList
          }
        }
        if (isPush) {
          tempChooseArr.push({
            yearName: selecedYear,
            mouthArr: checkList,
            mouthFlag
          })
        }
        if(this.isSingleSelect){//如果 单选，去掉之前的
          if(size(tempChooseArr)>1){
            tempChooseArr.shift();
          }
        }
      } else {
        if (checkList.length > 0) {
          tempChooseArr.push({
            yearName: selecedYear,
            mouthArr: checkList,
            mouthFlag
          })
        }
      }
      this.tempChooseArr = tempChooseArr
    },
    changeCheck(e) {
      this.baseChangeCheck();
      isCheckMore(this)
      if(this.isItemBindClick&&size(this.checkList)>0){
          this.confirmExport();
      }
    },
    // 上一年下一年
    preYear() {
      let selecedYear = toInteger(this.selecedYear)
      let count=size(this.tabObj.items);
      if (selecedYear > 0) {
        this.selecedYear = selecedYear - count
        this.initMonthData()
      }
    },
    nextYear() {
      let count=size(this.tabObj.items);
      let selecedYear = toInteger(this.selecedYear)
      this.selecedYear = selecedYear + count
      this.initMonthData()
    },
    getCurrentTitle() {
      let count=size(this.tabObj.items);
      let selecedYear = toInteger(this.selecedYear)
      let nextSelecedYear = selecedYear + (count-1)
      return `${selecedYear}年 - ${nextSelecedYear}年`;
    },
  }
}
</script>
